import Icon from '../components/Icon.vue'

Icon.register({
  restroom: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M128 128c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM512 128c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM639.3 354.5c3.7 15.1-8.3 29.5-24.5 29.5h-54.8v104c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-104h-54.8c-16.2 0-28.2-14.4-24.7-29.5l45.6-185.8c3.3-13.5 15.5-23 29.8-24.2 15 9.7 32.8 15.5 52 15.5 19.2 0 37-5.8 52-15.5 14.3 1.2 26.5 10.7 29.8 24.2zM336 0c8.8 0 16 7.2 16 16v480c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-480c0-8.8 7.2-16 16-16h32zM180.1 144.4c24.6 2.1 43.9 22.5 43.9 47.6v136c0 13.3-10.7 24-24 24h-8v136c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-136h-8c-13.3 0-24-10.7-24-24v-136c0-25.1 19.3-45.5 43.9-47.6 15 9.8 32.9 15.6 52.1 15.6s37.1-5.8 52.1-15.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/restroom.js
// module id = 1841
// module chunks = 0